import { EXPAND_ITEM, INITIATE_EXPAND_SECTION } from "../constants/actionTypes";

export const initiateExpandSection = (
  section,
  expandedCompanies = [],
  expandedSites = [],
  expandedZones = []
) => ({
  type: INITIATE_EXPAND_SECTION,
  section,
  expandedCompanies,
  expandedSites,
  expandedZones,
});

export const expandItem = (section, expandedLevel, newId) => ({
  type: EXPAND_ITEM,
  section,
  expandedLevel,
  newId,
});
